import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
// 收益中心
export default [{
  path: "/promotionCenter",
  name: "promotionCenter",
  component: function component() {
    return import("../../../views/promotion_center/index.vue");
  },
  meta: {
    title: "收益中心",
    foot: true
  }
}, {
  path: "/incomeList",
  name: "incomeList",
  component: function component() {
    return import("../../../views/promotion_center/incomeList.vue");
  },
  meta: {
    title: "收益中心",
    foot: true
  }
}, {
  path: "/promotion/incomeDetailList",
  name: "incomeDetailList",
  component: function component() {
    return import("../../../views/promotion_center/incomeDetailList.vue");
  },
  meta: {
    title: "收益明细",
    foot: true
  }
}, {
  path: "/promotion/incomeDetailWeb",
  name: "incomeDetailWeb",
  component: function component() {
    return import("../../../views/promotion_center/incomeDetailWeb.vue");
  },
  meta: {
    title: "收入详情",
    foot: true
  }
}, {
  path: "/promotion/recordWeb",
  name: "promotionRecordWeb",
  component: function component() {
    return import("../../../views/promotion_center/recordEarnings.vue");
  },
  meta: {
    title: "提现记录",
    foot: true
  }
}, {
  path: "/promotion/withdrawalDetails",
  name: "promotionWithdrawalDetails",
  component: function component() {
    return import("../../../views/promotion_center/withdrawalDetails.vue");
  },
  meta: {
    title: "提现详情",
    foot: true
  }
}, {
  path: "/promotion/roleIncomeDetails",
  name: "roleIncomeDetails",
  component: function component() {
    return import("../../../views/promotion_center/roleIncomeDetails.vue");
  },
  meta: {
    title: "",
    foot: true
  }
}, {
  path: "/promotion/specialistIncomeDetails",
  name: "specialistIncomeDetails",
  component: function component() {
    return import("../../../views/promotion_center/specialistIncomeDetails.vue");
  },
  meta: {
    title: "",
    foot: true
  }
}, {
  path: "/promotion/storeExpansion",
  name: "storeExpansion",
  component: function component() {
    return import("../../../views/promotion_center/storeExpansion.vue");
  },
  meta: {
    title: "拓店记录",
    foot: true
  }
}, {
  path: "/promotion/applycaptain",
  name: "applycaptain",
  component: function component() {
    return import("../../../views/promotion_center/applycaptain.vue");
  },
  meta: {
    title: "队长权益",
    foot: true
  }
}, {
  path: "/promotion/balanceWithdrawal",
  name: "promotionBalanceWithdrawal",
  component: function component() {
    return import("../../../views/promotion_center/balanceWithdrawal.vue");
  },
  meta: {
    title: "提现管理",
    foot: true
  }
}, {
  path: "/promotion/withdrawal",
  name: "promotionWithdrawal",
  component: function component() {
    return import("../../../views/promotion_center/withdrawal.vue");
  },
  meta: {
    title: "全部提现",
    foot: true
  }
}, {
  path: "/promotion/withdrawal",
  name: "promotionWithdrawal",
  component: function component() {
    return import("../../../views/promotion_center/withdrawal.vue");
  },
  meta: {
    title: "全部提现",
    foot: true
  }
}, {
  path: "/promotion/agentAccountList",
  name: "agentAccountList",
  component: function component() {
    return import("../../../views/promotion_center/withdrawalList.vue");
  },
  meta: {
    title: "代提账户",
    foot: true
  }
}, {
  path: "/promotion/paymentHistory",
  name: "promotionPaymentHistory",
  component: function component() {
    return import("../../../views/promotion_center/payments/paymentList.vue");
  },
  meta: {
    title: "打款凭证提交记录",
    foot: true
  }
}, {
  path: "/promotion/addPayment",
  name: "promotionAddPayment",
  component: function component() {
    return import("../../../views/promotion_center/payments/addPayment.vue");
  },
  meta: {
    title: "新增打款凭证",
    foot: true
  }
}, {
  path: "/promotion/paymentDetail",
  name: "promotionPaymentDetail",
  component: function component() {
    return import("../../../views/promotion_center/payments/paymentDetail.vue");
  },
  meta: {
    title: "打款凭证详情",
    foot: true
  }
}, {
  path: "/promotion/supplierIncome",
  name: "promotionSupplierIncome",
  component: function component() {
    return import("../../../views/promotion_center/supplierIncome.vue");
  },
  meta: {
    title: "供应商收益",
    foot: true
  }
}];